"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nx_castSpell = exports.updateTickAll = exports.removeDead = exports.killAll = exports.kill = exports.create = exports.getAll = void 0;
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var diveSpell_firewall_sidecar_1 = require("../diveSpell_firewall-sidecar");
var diveSpell_lightningCloud_sidecar_1 = require("../diveSpell_lightningCloud-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create(id, fromI, fromJ, targetI, targetJ, spell_anim) {
    id = diveSimulationManager_sidecar_1.diveSimulationManager.synced_createId(id);
    console.log('syncedImportantRando', 'create spell');
    var gen = spell_anim({
        fromI: fromI,
        fromJ: fromJ,
        startI: targetI,
        startJ: targetJ,
        seed: diveSimulationManager_sidecar_1.diveSimulationManager.getSyncedImportantRando().randomNewSeed(),
    });
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        delayTicksLeft: 0,
        generator: gen,
    };
    objs.push(obj);
    // moveToXY(obj, obj.x, obj.y)
    // TODO: sfx
    // if (obj.team === 0) {
    //   voyageSounds.playShootCrewGun()
    // } else {
    //   voyageSounds.playShootAlienGun()
    // }
    return obj;
}
exports.create = create;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) { });
}
exports.removeDead = removeDead;
function updateTickAll() {
    imports_1.l.forEach(objs, function (c) {
        updateTick(c);
    });
    removeDead();
}
exports.updateTickAll = updateTickAll;
function updateTick(obj) {
    // TODO: allow actions again?
    if (obj.isDead) {
        return;
    }
    if (obj.delayTicksLeft > 0) {
        obj.delayTicksLeft--;
        // obj.action()
        return true;
    }
    if (obj.generator) {
        var result = obj.generator.next();
        if (result.done) {
            obj.generator = null;
            kill(obj);
            return false;
        }
        if (result.value.delay) {
            obj.delayTicksLeft = result.value.delay - 1;
        }
        else {
            obj.delayTicksLeft = 0;
        }
        // if (result.value.action) {
        //   obj.action = result.value.action
        // } else {
        //   obj.action = nullAction
        // }
        return true; // Still running animation
    }
    return false;
}
function nx_castSpell(msg) {
    // TODO: get player selected ability
    // let spell = diveSpell_firewall
    // TODO: get from multiplayer cursor
    var _a = voyageWebsockets_sidecar_1.voyageWebsockets.isUsEx(msg.fromMultiId), isUs = _a.isUs, from = _a.from;
    var crew = diveCrew_sidecar_1.diveCrew.findById(msg.fromCrewId);
    if (!crew) {
        console.warn('no selected crew to cast from');
        return null;
    }
    var tryUseSpellCount = function (spell, crew) {
        var _a, _b;
        var spellCount = 0;
        // TODO: better way of doing this
        if (spell === diveSpell_firewall_sidecar_1.diveSpell_firewall) {
            if ((_a = crew.weaponSlot) === null || _a === void 0 ? void 0 : _a.ability1Uses) {
                spellCount = crew.weaponSlot.ability1Uses;
                crew.weaponSlot.ability1Uses--;
            }
        }
        if (spell === diveSpell_lightningCloud_sidecar_1.diveSpell_lightningCloud) {
            if ((_b = crew.weaponSlot) === null || _b === void 0 ? void 0 : _b.ability2Uses) {
                spellCount = crew.weaponSlot.ability2Uses;
                crew.weaponSlot.ability2Uses--;
            }
        }
        if (spellCount < 0) {
            return false;
        }
        return true;
    };
    var tryCast = function (spell, crew) {
        if (spell && tryUseSpellCount(spell, crew)) {
            var obj = create(0, crew.i, crew.j, msg.tx, msg.ty, spell.spell_anim);
            return obj;
        }
        return null;
    };
    if (isUs) {
        var activeSpell = voyagePicker_sidecar_1.voyagePicker.get().selectedSpell;
        return tryCast(activeSpell, crew);
    }
    else {
        if (from) {
            var activeSpell = from.selectedSpell;
            return tryCast(activeSpell, crew);
        }
        return null;
    }
}
exports.nx_castSpell = nx_castSpell;
